import { Record, List } from 'immutable';

const defaultValues = {
  id: null,
  categoryName: '',
  description: '',
  ordinal: 0,
};

export default class RecipeCategory extends Record(defaultValues, RecipeCategory) {
  constructor(values) {
    super({
      ...values,
    });
  }
}

export const RecipeCategories = (data) => {
  let recipeCategories = new List();
  if (data) {
    data.forEach((value) => {
      const { category } = value;
      recipeCategories = recipeCategories.push(new RecipeCategory(category || value));
    });
  }
  return recipeCategories;
};
